import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdatePopupComponent } from './update-popup.component';

@NgModule({
  imports: [CommonModule],
  declarations: [UpdatePopupComponent],
  exports: [UpdatePopupComponent]
})
export class UpdatePopupModule {}
